import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { CloseCircleOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'

import Text from '~/core/Text'
import Box from '~/core/Box'
import getColor from '~/lib/getColor'

import styles from './itarModalStyles.css'

type ExportControlProps = {
    userEmail: string
    visible: boolean
    setVisible: (visible: boolean) => void
    userId: number
}

const ExportControlModal: FC<ExportControlProps> = ({
    userEmail,
    visible,
    setVisible,
    userId,
}) => {
    const navigate = useNavigate()

    const handleClose = () => {
        setVisible(false)
        navigate(`/admin/app/user/${userId}`)
    }

    return (
        <Modal
            centered
            maskClosable={false}
            title={null}
            closable={false}
            footer={null}
            visible={visible}
            bodyStyle={{ height: '222px', width: '520px', padding: '24px' }}
        >
            <Box display="flex" direction="col">
                {' '}
                <Box>
                    <CloseCircleOutlined
                        style={{
                            color: getColor('error'),
                            marginTop: '1.5px',
                            marginLeft: '1.5px',
                            fontSize: '21px',
                        }}
                    />
                    <Text
                        style={{
                            color: getColor('blackAlpha65'),
                            fontSize: '16px',
                            marginLeft: '17.5px',
                            fontWeight: 400,
                        }}
                    >
                        {' '}
                        This user has not accepted Fictiv’s Export Control Terms
                        of Service.
                    </Text>
                </Box>
                <Text
                    className={styles.messageStyle}
                    style={{ marginLeft: '40px', marginTop: '4px' }}
                >
                    Before you can upload On-Behalf-Of (OBO) this user, please
                    contact the user to have them log on to the platform and
                    accept Fictiv’s Export Control Terms of Service.
                </Text>
                <Box marginTop="25px" justifyContent="end">
                    <Button
                        name="Download-annotated-pdf"
                        onClick={handleClose}
                        color={getColor('blackAlpha65')}
                        style={{
                            marginRight: '4px',
                            width: '61px',
                            height: '32px',
                            fontSize: '14px',
                            fontWeight: 400,
                            padding: '5px 12px',
                        }}
                        data-test-target="download-annotated-pdf"
                    >
                        Close
                    </Button>
                    <Button
                        type="primary"
                        name="close-rfq-required-modal"
                        href={`mailto:${userEmail}?subject=Please accept Fictiv’s Terms of Service&body=Hi! Thank you for being a Fictiv user. In order for us to upload parts on your behalf, we need you to accept Fictiv’s Terms of Service. To accept the Terms of Service, please log into the Fictiv platform at https://app.fictiv.com to view the Terms of Service dialog and click on “Agree”. You will need to accept the Terms of Service only once.`}
                        style={{
                            width: '108px',
                            height: '32px',
                            fontSize: '14px',
                            fontWeight: 400,
                            textAlign: 'center',
                            padding: '0px 12px',
                        }}
                        data-test-target="close-rfq-required-modal"
                    >
                        Contact user
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}

export default ExportControlModal
